// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3Kl8x","label":"CategoryService_label__3_ZNs","location":"CategoryService_location__1yYkS"};